import { Path, Svg } from './styles';
import { IconProps } from './types';

<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="" fill="#344054" />
</svg>;

const path = [
  'M14.0007 7.33464L13.584 6.41797L12.6673 6.0013L13.584 5.58464L14.0007',
  '4.66797L14.4173 5.58464L15.334 6.0013L14.4173 6.41797L14.0007 7.33464ZM10.6673',
  '10.668L9.83398 8.83464L8.00065 8.0013L9.83398 7.16797L10.6673 5.33464L11.5007',
  '7.16797L13.334 8.0013L11.5007 8.83464L10.6673 10.668ZM14.0007 11.3346L13.584',
  '10.418L12.6673 10.0013L13.584 9.58464L14.0007 8.66797L14.4173 9.58464L15.334',
  '10.0013L14.4173 10.418L14.0007 11.3346ZM4.66732 15.3346C4.30065 15.3346 3.98687',
  '15.2042 3.72598 14.9433C3.46465 14.682 3.33398 14.368 3.33398 14.0013V2.0013C3.33398',
  '1.63464 3.46465 1.32064 3.72598 1.0593C3.98687 0.798413 4.30065 0.667969 4.66732',
  '0.667969H11.334C11.7007 0.667969 12.0147 0.798413 12.276 1.0593C12.5369 1.32064 12.6673',
  '1.63464 12.6673 2.0013V4.66797H11.334V4.0013H4.66732V12.0013H11.334V11.3346H12.6673V14.0013C12.6673',
  '14.368 12.5369 14.682 12.276 14.9433C12.0147 15.2042 11.7007 15.3346 11.334 15.3346H4.66732ZM4.66732',
  '13.3346V14.0013H11.334V13.3346H4.66732ZM4.66732 2.66797H11.334V2.0013H4.66732V2.66797Z',
].join(' ');

export const IconMobilePhoneWithSparkles = ({ width = 16, height = 16, color, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color || 'currentColor'} />
  </Svg>
);

export default IconMobilePhoneWithSparkles;
